var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMembershipCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.717,
    y: 1.65,
    width: 25.567,
    height: 17.7,
    rx: 0.983,
    stroke: "#e95832",
    strokeWidth: 1.967
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.533 14.925v-.983a1.966 1.966 0 00-1.966-1.967H6.632a1.967 1.967 0 00-1.966 1.967v.983M8.6 10.008a1.967 1.967 0 100-3.933 1.967 1.967 0 000 3.933z",
    stroke: "#e95832",
    strokeWidth: 1.475,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.483 8.533h8.85M15.483 12.467h8.85",
    stroke: "#e95832",
    strokeWidth: 1.967,
    strokeLinecap: "round"
  })));
}
export default __webpack_public_path__ + "static/media/membership_card.a9682039.svg";
export { SvgMembershipCard as ReactComponent };